import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { apiRootSelector } from '@schir-int-client/api-root';
import { filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
	loadMonthlyStatistikAction,
	loadStatistikAction,
	loadVerfahrenAktionStatistikAction,
	loadVerfahrenAktionStatistikSuccessAction,
	loadZaehlblattStatistikAction,
	monthlyStatistikLoadedAction,
	statistikLoadedAction,
	zaehlblattStatistikLoadedAction,
} from './statistik.actions';
import { StatistikService } from './statistik.service';
import {
	MonthlyStatistik,
	StatistikResource,
	VerfahrenAktionStatistik,
	ZaehlblattStatistikResource,
} from './statistik.model';
import { adminRootSelector } from '@schir-int-client/admin-shared';
import { AppState } from '../../../../apps/int-client/src/app/shared/store/app-state.model';
import { combineLatest } from 'rxjs';
import { isNil } from 'lodash-es';

@Injectable()
export class StatistikEffects {
	constructor(
		private actions: Actions,
		private statistikService: StatistikService,
		private store: Store<AppState>
	) {}

	loadStatistik = createEffect(() =>
		this.actions.pipe(
			ofType(loadStatistikAction),
			withLatestFrom(this.store.select(apiRootSelector)),
			switchMap(([, apiRoot]) => {
				return this.statistikService
					.getStatistik(apiRoot)
					.pipe(map((statistik: StatistikResource) => statistikLoadedAction({ statistik })));
			})
		)
	);

	loadMonthlyStatistik = createEffect(() =>
		combineLatest([
			this.actions.pipe(ofType(loadMonthlyStatistikAction)),
			this.store.select(adminRootSelector).pipe(filter(r => !isNil(r))),
		]).pipe(
			switchMap(([, adminRoot]) => {
				return this.statistikService
					.loadMonthlyStatistik(adminRoot)
					.pipe(map((statistik: MonthlyStatistik) => monthlyStatistikLoadedAction({ statistik })));
			})
		)
	);

	loadZaehlblattStatistik = createEffect(() =>
		combineLatest([
			this.actions.pipe(ofType(loadZaehlblattStatistikAction)),
			this.store.select(adminRootSelector).pipe(filter(r => !isNil(r))),
		]).pipe(
			switchMap(([, adminRoot]) => {
				return this.statistikService
					.loadZaehlblattStatistik(adminRoot)
					.pipe(
						map((statistik: ZaehlblattStatistikResource) => zaehlblattStatistikLoadedAction({ statistik }))
					);
			})
		)
	);

	loadVerfahrenAktionStatistik = createEffect(() =>
		combineLatest([
			this.actions.pipe(ofType(loadVerfahrenAktionStatistikAction)),
			this.store.select(adminRootSelector).pipe(filter(r => !isNil(r))),
		]).pipe(
			switchMap(([{ von, bis }, adminRoot]) => {
				return this.statistikService
					.loadVerfahrenAktionStatistik(adminRoot, von, bis)
					.pipe(
						map((statistik: VerfahrenAktionStatistik) =>
							loadVerfahrenAktionStatistikSuccessAction({ statistik })
						)
					);
			})
		)
	);
}
